<template>
  <div class="question-view ">
    <div class="quest">
      <div class="title">
        <vue-mathjax :formula="form.title" :safe="false"/>
      </div>
      <div class="matrix">
        <div class="column" v-for="(col, idx) in matrix" :key="idx">
          <template v-for="(row, index) in col">
            <div class="direction E" v-if="row.type == -2" :key="index"></div>
            <div class="direction W" v-else-if="row.type == -3" :key="index"></div>
            <div class="direction S" v-else-if="row.type == -4" :key="index"></div>
            <div class="direction N" v-else-if="row.type == -5" :key="index"></div>
            <div :class="['row', row.type == -1 && 'hide', row.right && 'right', row.bottom && 'bottom']" :key="index" v-else>
              <!-- 明文 -->
              <span class="proclaimed" v-if="row.type == 0">{{ row.value }}</span>
              <input type="text" v-else-if="row.type == 1" v-model="row.value" name="" id="" @input="debounce(updateValue, 500, row)">
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- <div class="quest-img" v-if="form.img_url || form.imgUrl" @click="$emit('urlToParent', form.img_url || form.imgUrl)">
      <img :src="form.img_url || form.imgUrl" :style="imgStyle" alt="">
    </div> -->
  </div>
</template>

<script>
import { debounce } from '../../plugins/debounce'

export default {
  props: ['form', 'mode'],
  data() {
    return {
      html: '', 
      imgStyle: null,
      valNum: 0,
      answer_results: {
        id: null,
        student_choices: []
      },
      recordQuestion: [],

      matrix: []
    }
  },
  watch: {
    'form.id': {
      handler() {
        this.initData()
      },
      deep: true
    }
  },
  methods: {
    debounce, 
    updateValue(item) {
      // console.log(item)
      item.value = item.value.trim()
    },
    initData() {
      this.recordQuestion = []
      
      let content = JSON.parse(this.form.content.replace(/\(\)/g, ''))
      // console.log(content)
      for(let i = 0; i < content.length; i ++) {
        let blocks = content[i]
        for(let j = 0; j < blocks.length; j++) {
          let block = blocks[j],
          nextBlock = blocks[j + 1]
          if(block.type >= 0 && nextBlock && nextBlock.type < 0) {
            block.right = true
          }

          if(block.type >= 0 && (content[i + 1] && content[i + 1][j].type < 0)) {
            block.bottom = true
          }
        }
      }
      this.matrix = content
    }
  },
  created() {
    this.initData()
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>
.question-view {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-color: #fff !important;
  // border-radius: 10px;

  .matrix {
    margin-top: 20px;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;

    .column {
      width: 100%;
      display: flex;

      .direction {
        width: 38px;
        height: 38px;
        box-sizing: border-box;
        position: relative;
        border: 20px solid transparent;
      }

      .N {
        border-bottom-color: #717171;
      }
      .S {
        border-top-color: #717171;
      }
      .E {
        border-left-color: #717171;
      }
      .W {
        border-right-color: #717171;
      }

      .row {
        width: 40px;
        height: 40px;
        padding: 2px;
        box-sizing: border-box;
        position: relative;
        border: 2px solid #717171;
        border-right: none;
        border-bottom: none;
        background-color: #ffcca5;

        .proclaimed {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 700;
        }

        input[type="text"] {
          outline: none;
          border: none;
          width: 100%;
          height: 100%;
          background-color: transparent;
          text-align: center;
          color: #ff3550;
          font-weight: 700;
        }
      }

      .right:before {
        content: '';
        position: absolute;
        top: -2px;
        right: -2px;
        width: 2px;
        height: calc(100% + 2px);
        background-color: #717171;
      }

      .bottom:after {
        content: '';
        position: absolute;
        bottom: -2px;
        right: -2px;
        width: calc(100% + 4px);
        height: 2px;
        background-color: #717171;
      }

      .row.hide {
        background-color: transparent;
        border: none;

        &:after, &:before {
          content: none;
        }
      }
    }
  }
  .quest-img {
    width: 833px;/*width: 833px;*/
    height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
      border-radius: 5px;
    }
  }
}
</style>
